var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlipV(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    enableBackground: "new 0 0 16 16",
    viewBox: "0 0 16 20",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.5365 0 0 1.5385 -.45052 -3.0769)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 8,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 8,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 8,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 8,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 8,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1,2 5.5,6 10,2 Z M 7.37,3 5.5,4.662 3.63,3 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "5.5 11 1 15 10 15"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlipV);
export default __webpack_public_path__ + "static/media/flip-v.d4023bb9da96ea145d07fd8f3eca7b9f.svg";
export { ForwardRef as ReactComponent };